import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Custom hook to fetch service data from API
 * @param {string} slug - Service slug (library, museum, nursery, etc.)
 * @returns {object} { data, loading, error, refetch }
 */
export function useService(slug) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${BACKEND_URL}/api/services/${slug}`);
      setData(response.data);
    } catch (err) {
      console.error(`Error fetching ${slug} data:`, err);
      setError(err.response?.data?.detail || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) {
      fetchData();
    }
  }, [slug]);

  return { data, loading, error, refetch: fetchData };
}
